import { EntityRepository } from "../";
import { KeyValue } from "../domain";


export class ConfigRepository implements EntityRepository<KeyValue> {
  private _repo: EntityRepository<KeyValue>;

  constructor(repo:EntityRepository<KeyValue>) {
    this._repo = repo;
  }

  checkUniqueString(attribute: (obj: KeyValue) => string, value: string): boolean {
    return this._repo.checkUniqueString(attribute, value);
  }

  getAll(): KeyValue[] {
    return this._repo.getAll();
  }

  get(uuid: string): KeyValue | undefined {
    return this._repo.get(uuid);
  }

  put(uuid: string, value: KeyValue): Promise<void> {
    return this._repo.put(uuid, value);
  }

  async putAll(values: KeyValue[]) {
    return this._repo.putAll(values);
  }

  delete(uuid: string): void {
    this._repo.delete(uuid);
  }

  findConfig(key:string) : KeyValue | undefined {
    return this._repo
    .getAll()
    .find(kv => kv.key === key);    
  }
}